<script>
  let errorMessage = "";
  let accountNumber, pin, rememberMe;

  async function login()
  {
    let response;

    try
    {
      const response = await fetch(`${window.API_URL}/api/Account/Login`,
      {
        method: 'POST',
        mode: 'cors',
        headers:
        {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
        {
          AccountNumber: accountNumber.value,
          Pin: pin.value,
          RememberMe: rememberMe.checked
        })
      });

      if(!response.ok)
      {
        const text = await response.text();
        throw new Error(text);
      }

      errorMessage = "";
      location.href = "/";
      
    }

    catch(ex)
    {
      errorMessage = ex.message;
    }
  }
</script>

<div class="container full-height flex-center">
<div class="columns full-width">
  <div class="column col-6 col-xs-12 p-centered">
    {#if errorMessage}
    <div class="toast toast-error">
      <button on:click="{() => errorMessage = ''}" class="btn btn-clear float-right"></button>
      { errorMessage }
    </div>
    {/if}
    <div class="form-group">
      <label class="form-label" for="accountNumber">Account Number</label>
      <input bind:this={accountNumber} class="form-input" id="accountNumber" type="text" placeholder="Account Number">
    </div>
    <div class="form-group">
      <label class="form-label" for="Pin">PIN Code</label>
      <input bind:this={pin} class="form-input" id="pin" type="password" placeholder="PIN Code">
    </div>
    <div class="form-group">
      <label class="form-switch">
        <input bind:this={rememberMe} type="checkbox" id="RememberMe">
        <i class="form-icon"></i>Remember Me
      </label>
    </div>
    <div class="form-group text-center">
      <button on:click="{login}" class="btn btn-lg">Login</button>
    </div>
  </div>
</div>
</div>